import React from 'react';
import { useNavigate } from 'react-router-dom';
import LootboxSheet from './LootboxSheet';
import LootboxHero from './LootboxHero';
import { rarityColor } from '../utils/lootboxRewards';
import '../styles/chestInfoModal.css';
import { useTranslation } from 'react-i18next';
import { entityText } from '../../../i18n/entityText';

/** Key popup: what keys are for + owned counter, or "Buy" → Shop / Keys tab when none. */
export default function KeyInfoModal({ keyType, quantity, onClose }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const name = entityText(t, 'key_type', keyType.id, 'name', keyType.name);
  const color = rarityColor(keyType.rarity, '#fff');
  const owned = quantity > 0;

  return (
    <LootboxSheet
      title={name || t('reward.key', 'Key')}
      titleColor={color}
      onClose={onClose}
      footer={owned ? null : (closeThen) => (
        <button
          type="button"
          className="app-btn app-btn--green"
          onClick={() => closeThen(() => navigate('/shop', { state: { tab: 'KEY' } }))}
        >
          {t('common.buy', 'Buy')}
        </button>
      )}
    >
      <p className="chest-info-text">{t('lootbox.key_hint', 'Use a key to open a chest and get a reward')}</p>
      <LootboxHero
        imageUrl={keyType.imageUrl}
        alt={name}
        color={color}
        quantity={owned ? quantity : null}
      />
    </LootboxSheet>
  );
}
